import { apollo } from '@/plugins/apollo'

// graphql files
import list from 'GraphQL/queries/tpmsAlerts/list.gql'

export default {
  async getList ({ rootState, commit }, params) {
    try {
      const {
        rangeType,
        dateFrom,
        dateTo,
        eventTypes,
        unitIds,
        page,
        pageSize
      } = params

      const response = await apollo.query({
        query: list,
        variables: {
          apiToken: rootState.session.apiToken, // set from session store if needed
          unitIds: unitIds && unitIds.length ? unitIds : null,
          rangeType,
          dateFrom: rangeType === 'CUSTOM' ? dateFrom : null,
          dateTo: rangeType === 'CUSTOM' ? dateTo : null,
          eventTypes: eventTypes && eventTypes.length ? eventTypes : null,
          page,
          pageSize
        },
        fetchPolicy: 'network-only'
      })

      const { tpmsEvents } = response.data

      if (tpmsEvents.status === 'OK') {
        commit('setList', {
          items: tpmsEvents.result,
          total: tpmsEvents.total
        })
        commit('toggle', {
          method: 'getList',
          status: 'OK',
          total: tpmsEvents.total,
          totalPages: tpmsEvents.totalPages
        })
      } else {
        commit('toggle', { method: 'getList', status: 'ERROR', errors: tpmsEvents.errors })
      }
    } catch (e) {
      commit('toggle', { method: 'getList', status: 'ERROR', errors: [e.message] })
    }
  }
}
